// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M2 18h16V4H9a.996.996 0 01-.707-.293L6.586 2H2v16zm17 2H1a1 1 0 01-1-1V1a1 1 0 011-1h6c.266 0 .52.105.707.293L9.414 2H19a1 1 0 011 1v16a1 1 0 01-1 1z\"/></svg>";
// Exports
module.exports = code;